import { useCallback } from 'react';

import { RequestPayload } from '../api/types';
import { QueryTableParams } from '../components/common/table/types';
import { stringifySort } from '../components/common/table/utils';

type useFetchDataProps<D> = {
  method: (payload: RequestPayload) => Promise<ApiResponse<Paginated<'data', D> & { content?: string, filename?: string }>>
}

export function useFetchData<D>({ method }: useFetchDataProps<D>) {

  const fetchData = useCallback(async ({ pagination, sort, filterRaw, forDownload }: QueryTableParams<D>) => {
    const response = await method({
      limit: pagination.pageSize,
      offset: pagination.pageSize * (pagination.page - 1),
      sort: stringifySort(sort),
      filter: filterRaw,
      download: forDownload ? '1' : undefined
    });

    return {
      code: response?.code,
      total: response?.data?.total || 0,
      data: response?.data?.data || [],
      content: response?.data?.content,
      filename: response?.data?.filename,
      message: response?.message,
    };
  }, [method]);

  return [fetchData];
}